import classNames from "classnames";
import React from "react";

/**
 * Renders form field label
 */
export const FormLabel = (props: {
    id?: string;
    label?: string;
    placeholder?: string;
    labelCSSClass?: string;
    labelPlacement?:
        | "top"
        | "left"
        | "right"
        | "bottom"
        | "outside"
        | "dynamic"
        | "static";
    onLabelClick?: () => void;
}): React.ReactNode => {
    const text = props.label || props.placeholder;
    if (!text) {
        return null;
    }

    const classes = classNames({
        form__label: true,
        [`${props.labelCSSClass}`]: props.labelCSSClass ? true : false,
        [`form__label--${props.labelPlacement}`]: !!props.labelPlacement,
    });

    return (
        <label
            className={classes}
            htmlFor={props.id}
            onClick={props.onLabelClick}
        >
            {text}
        </label>
    );
};
